import { LoadingService } from '@/core/services/loading.service';
import { UserCreateRequestDto } from '@/core/models/user';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@/core/services/open-api/user.service';
import { User } from '@/core/models/user';
import { UserSettings } from '@/core/models/user-settings';
import { CrmWebhookEvent, CrmWebhookService } from '@/core/services/crm-webhook.service';
import { StdToasts, ToastService } from '@/core/services/toast.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-register-page',
    templateUrl: './register.component.html',
    // styleUrls: ['./register.component.scss'],
    standalone: false,
})
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    displayValidationMessages = false;

    constructor(
        private readonly crmWebhookService: CrmWebhookService,
        private readonly toastService: ToastService,
        private router: Router,
        private readonly translate: TranslateService,
        private userService: UserService,
        private readonly loadingService: LoadingService,
        private fb: FormBuilder,
    ) {
        // legacy email pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        this.registerForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    get emailControl(): AbstractControl {
        return this.registerForm.get('email')!;
    }

    ngOnInit(): void {}

    public register(): void {
        if (this.registerForm.invalid) {
            this.displayValidationMessages = true;
            return;
        }
        this.loadingService.setLoading(true);

        const settings = new UserSettings();
        // Color and Language are sent as constant
        settings.color = 'light';

        if (this.translate.getBrowserLang() === 'de') {
            settings.language = 'de';
            settings.timeFormat = 'HH:mm';
            settings.dateFormat = 'DD.MM.YYYY';
        } else {
            settings.language = 'en';
        }

        const termsAndPrivacyAccepted = true;
        if (termsAndPrivacyAccepted) {
            const email: string = this.registerForm.get('email')!.value;

            const user: UserCreateRequestDto = {
                firstName: 'firstName',
                lastName: 'lastName',
                email,
                settings,
            };
            this.userService.createAccount(user).subscribe({
                next: (_newUser: User) => {
                    // Send new account to CRM
                    void this.crmWebhookService.send(CrmWebhookEvent.createAccountWithoutNewsletter, {
                        email,
                        language: settings.language,
                    });

                    this.loadingService.setLoading(false);
                    void this.router.navigate(['/register-finished']);
                },
                error: (err) => {
                    console.error('user creation failed', err);
                    if (err?.error?.error?.code !== 'ACC-001') {
                        // 409 (duplicate email) is already handled by the global API error handler (ErrorInterceptor).
                        // For all other errors (e.g. 400 validation, 500), we show a fallback toast here.
                        this.toastService.toast(StdToasts.STANDARD_ERROR);
                    }
                    this.loadingService.setLoading(false);
                },
            });
        }
    }
}
